import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'accordion-card',
  host: { '[class.disabled]': 'disabled' },
  styleUrls: ['./accordion-card.component.scss'],
  templateUrl: './accordion-card.component.html',
})
export class AccordionCardComponent {
  @Input()
  footerCard: boolean = false;

  @Input()
  open = false;

  @Input()
  disabled = false;

  @Input() invalid = false;

  @Input() legacyHandling = false;

  @Output()
  opened = new EventEmitter<void>();

  @Output()
  closed = new EventEmitter<void>();

  toggle() {
    if (!this.disabled && !this.invalid) {
      const open = !this.open; //Don't change it here, emit the event and let the parent catch it and change the input value for it
      if (open) {
        this.opened.emit();
      } else {
        this.closed.emit();
      }

      if (this.legacyHandling) this.open = !this.open;
    }
  }
}
